import {lazy} from 'react';
export const SingleUserPage = lazy(() => import('./SingleUserPage'));
